import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthForm } from "@/components/auth/AuthForm";
import { useAuth } from "@/hooks/useAuth";
import edugogyLogo from "@/assets/edugogy-logo.png";

export default function Auth() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    console.log('[Auth] Auth state changed:', { hasUser: !!user, loading });
    if (user && !loading) {
      console.log('[Auth] User is logged in, redirecting to dashboard');
      navigate("/dashboard");
    }
  }, [user, loading, navigate]);

  console.log('[Auth] Render - loading:', loading, 'user:', !!user);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-primary/5 via-background to-secondary/5 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          <p className="mt-4 text-muted-foreground">Loading authentication...</p>
        </div>
      </div>
    );
  }

  const handleAuthSuccess = () => {
    navigate("/dashboard");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 via-background to-secondary/5 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img 
            src={edugogyLogo} 
            alt="Edugogy" 
            className="mx-auto mb-4 max-w-[280px] sm:max-w-sm md:max-w-md lg:max-w-lg h-auto object-contain"
          />
        </div>
        <AuthForm onSuccess={handleAuthSuccess} />
      </div>
    </div>
  );
}